const MAX_FILE_SIZE = { size: 262144000, label: '250' }; // 250MB

module.exports = {
  MAX_FILE_SIZE,
};
